export interface InfoBarState {
  show: boolean;
  type?: 'warning' | 'info' | 'logout-warning';
  message?: string;
  translateParams?: any;
  action?: 'CALLBACK'; // | 'SOMETHING' | 'OTHER_SOMETHING' |
  callback?: () => any;
  timeLeft?: string;
}
